import React, { useEffect, useRef, useState } from "react";
import EasyBinTransfer_Breadcrumbs from "../../EasyBinTransfer_Breadcrumbs";
import { Grid } from "@mui/material";
import {
  CmpButton,
  CmpDatePickerField,
  CmpInputField,
  CmpSelectField,
  CmpTypographyField,
} from "../../../../Component/Common/ToolBox/ToolBox";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Src_Set } from "../../SliceEasyBinTransfer";
import {
  GetItem,
  GetDelete,
  GetSrc,
  fBinNameFromKey,
  fIsEnable,
} from "../../EasyBinTransferAction";
import GCToggleSearch from "../../../../Component/Common/ReuseableComponent/GCToggleSearch";
import { fAlertToast } from "../../../../Utility/Utilitys";

export default function EasyItemTransfer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxSrc = useSelector((state) => state.SliceEasyBinTransfer.value.Src);
  const onChangeInput = (e) => {
    dispatch(
      Src_Set({
        ...vRdxSrc,
        [e.target.name]: e.target.value,
      })
    );
  };
  const xfocus = (e) => {
    if (
      (e.key === "Enter" ||
      e?._reactName === "onClick") && vRdxSrc.BinCodeFrom != ""
    ) {
      document.getElementsByName("ItemName")[0]?.focus();
      // document.getElementById("Save").click();
    }
  };
  const FocusOnLoad = useRef(null);
  useEffect(() => {
    FocusOnLoad.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex my-3">
        <EasyBinTransfer_Breadcrumbs />
      </div>
      <div className="BinTransferContainer">
        <div className="BinTransferData">
          <div className="gridStyle">
            <Grid
              container
              columnSpacing={1}
              rowSpacing={2}
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans ID"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"transId"}
                  xValue={vRdxSrc.DocNo}
                  xReadOnly={true}
                  xOnChange={() => {}}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans Date"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpDatePickerField
                  xValue={vRdxSrc.Date}
                  xOnChange={(newValue) =>
                    dispatch(
                      Src_Set({
                        ...vRdxSrc,
                        Date: newValue.$d,
                      })
                    )
                  }
                  xName={"Date"}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpSelectField
                  xValue={vRdxSrc.LocCode}
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"LocCode"}
                  xData={vRdxuserLoc}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Bin From"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              {/* <Grid item xs={3} sm={4} md={3} lg={3}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinCodeFrom"}
                  xValue={vRdxSrc.BinCodeFrom}
                  xReadOnly={true}
                  xOnChange={() => {}}
                />
              </Grid> */}
              <Grid item xs={8} sm={9} md={8} lg={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinNameFrom"}
                  xValue={vRdxSrc.BinNameFrom}
                  xReadOnly={true}
                  xOnChange={() => {}}
                /> */}
                <GCToggleSearch
                  xref={FocusOnLoad}
                  xtabIndex={"25"}
                  xName={"BinNameFrom"}
                  xType={"text"}
                  xValue={vRdxSrc.BinNameFrom}
                  xOnKeyUp={async (e) => {
                    await fBinNameFromKey(e, dispatch, xfocus);
                  }}
                  xReadOnly={fIsEnable() || vRdxSrc.DocNo != 0 ? true : false}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    await fBinNameFromKey(e, dispatch, xfocus);
                  }}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Item"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              {/* <Grid item xs={3} sm={4} md={3} lg={3}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"ItemCode"}
                  xValue={vRdxSrc.ItemCode}
                  xReadOnly={true}
                  xOnChange={() => {}}
                />
              </Grid> */}
              <Grid item xs={8} sm={9} md={8} lg={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"ItemName"}
                  xValue={vRdxSrc.ItemName}
                  xReadOnly={true}
                  xOnChange={() => {}}
                /> */}
                <GCToggleSearch
                  xtabIndex={"25"}
                  xName={"ItemName"}
                  xType={"text"}
                  xValue={vRdxSrc.ItemName}
                  xOnKeyUp={async (e) => {
                    if (e.key === "Enter" || e?._reactName === "onClick") {
                      if (vRdxSrc.ItemCode != "") {
                        document.getElementById("Next").click();
                      } else {
                        await GetItem(dispatch);
                      }
                    }
                    if (
                      e.key === "Backspace" ||
                      (e.key === "Delete" && vRdxSrc.ItemName == "")
                    ) {
                      dispatch(
                        Src_Set({
                          ...vRdxSrc,
                          ItemCode: "",
                        })
                      );
                    }
                  }}
                  xReadOnly={fIsEnable() ? true : false}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    if (vRdxSrc.ItemCode != "") {
                      document.getElementById("Next").click();
                    } else {
                      await GetItem(dispatch);
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className="mt-2"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Grid
                item
                lg={6}
                md={6}
                xs={6}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={async () => {
                    await GetDelete(navigate);
                  }}
                  xDisabled={fIsEnable()}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                xs={6}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                  xbtnName="Next"
                  xId="Next"
                  xOnClick={async () => {
                    if (vRdxSrc.BinCodeFrom == "") {
                      fAlertToast("FAILED", "Bin From Should not be empty");
                      return;
                    } else if (vRdxSrc.ItemCode == "") {
                      fAlertToast("FAILED", "Item Code Should not be empty");
                      return;
                    } else {
                      if (vRdxSrc.DocNo == 0) {
                        let resp = await GetSrc(dispatch);
                        resp.length > 0 && navigate("/EasyItemTransferDetail");
                      } else {
                        navigate("/EasyItemTransferDetail");
                      }
                    }
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}
